import Vapi from '@vapi-ai/web';

// Get Vapi public key from environment variables
const VAPI_PUBLIC_KEY = import.meta.env.VITE_VAPI_PUBLIC_KEY;
const defaultAssistantId = import.meta.env.VITE_VAPI_DEFAULT_ASSISTANT_ID;

console.log('🔑 Vapi configuration:', {
  hasPublicKey: !!VAPI_PUBLIC_KEY,
  publicKeyLength: VAPI_PUBLIC_KEY?.length,
  publicKeyPrefix: VAPI_PUBLIC_KEY ? VAPI_PUBLIC_KEY.substring(0, 20) + '...' : 'NOT_SET',
  hasDefaultAssistantId: !!defaultAssistantId,
  defaultAssistantId: defaultAssistantId || 'NOT_SET'
});

// Debug helper function
const debugLog = (category, message, data = null) => {
  const timestamp = new Date().toISOString();
  console.group(`🐛 [${timestamp}] ${category}`);
  console.log(message);
  if (data) {
    console.log('Data:', data);
  }
  console.groupEnd();
};

// For development, use a placeholder if not set
if (!VAPI_PUBLIC_KEY) {
  console.warn('⚠️ VITE_VAPI_PUBLIC_KEY is not set in environment variables');
  console.warn('⚠️ Please add your Vapi public key to the .env file');
  console.warn('⚠️ Using placeholder key for development - calls will not work');
}

// Initialize Vapi instance with placeholder if needed
console.log('🚀 Initializing Vapi instance...');
const vapi = VAPI_PUBLIC_KEY ? new Vapi(VAPI_PUBLIC_KEY) : null;

if (vapi) {
  // Add debug logging for Vapi events
  vapi.on('call-start', (event) => {
    console.log('🟢 [Vapi Event] Call started:', event);
  });

  vapi.on('call-end', (event) => {
    console.log('🔴 [Vapi Event] Call ended:', event);
  });

  vapi.on('error', (error) => {
    console.error('❌ [Vapi Event] Error:', error);
  });

  vapi.on('message', (message) => {
    console.log('💬 [Vapi Event] Message:', message);
  });

  vapi.on('speech-start', (event) => {
    console.log('🎤 [Vapi Event] Speech started:', event);
  });

  vapi.on('speech-end', (event) => {
    console.log('🔇 [Vapi Event] Speech ended:', event);
  });

  console.log('✅ Vapi instance initialized successfully');
} else {
  console.error('❌ Vapi instance not initialized - missing public key');
}

// Export both named and default exports for compatibility
export { vapi, defaultAssistantId };
export default vapi;